import { innerSearch } from 'api/Api';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

const CommonResult = () => {
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const { setPaymentState } = usePaymentState();

  const paramTid = new URLSearchParams(searchParams).get('tid');

  // InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(paramTid), {
    onSuccess: data => {
      const returnUrl = data.data.returnUrl;
      // 결제수단 Set
      const payType = String(data.data.display.payType).toLowerCase();
      const response = data.data.response;

      setPaymentState(prevState => ({
        ...prevState,
        resultMessage: data.data.response.resultMessage,
        resultCode: data.data.response.resultCode,
        tid: data.data.response.tid,
        orderId: data.data.response.orderId,
        returnUrl: data.data.returnUrl,
        descriptor: data.data.display.descriptor,
      }));

      if (response.resultStatus) {
        createFormAndSubmit(response, returnUrl);
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const createFormAndSubmit = (formData, returnUrl) => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${returnUrl}`);
    form.style.display = 'none';
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', String(value));
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  useEffect(() => {
    if (paramTid) {
      transactResult.mutate();
    }
  }, []);

  return <></>;
};

export default CommonResult;
